import React from "react"

interface FieldLabelProps {
  htmlFor: string
  children?: React.ReactNode
}

const FieldLabel: React.FC<FieldLabelProps> = ({ htmlFor, children }) => (
  <label htmlFor={htmlFor} className="block font-sans text-xs font-semibold transition-colors">
    {children}
  </label>
)

export default FieldLabel
